import { HStack, Text } from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

type RoundDiscountItemProps = {
  discount: {
    id: string;
    name: string;
    appliedAmount: number;
  };
};

export const RoundDiscountItem = ({ discount }: RoundDiscountItemProps) => {
  const { currencySymbol } = useGetClubCurrency();

  const formattedAmount = `${currencySymbol}${ConvertCentsToDollars(
    discount.appliedAmount
  )}`;

  return (
    <HStack
      justifyContent="space-between"
      marginLeft={9}
      alignItems="center"
      testID={`discount-item-${discount.name}`}
    >
      <Text variant="mainBaseMedium" color="text-success" lineHeight={32}>
        {discount.name}
      </Text>
      <Text variant="mainBaseMedium" color="text-success" lineHeight={32}>
        {`-${formattedAmount}`}
      </Text>
    </HStack>
  );
};
